import type { VirtualFile } from "../../files/VirtualFile"
import type { TaskName } from "../TaskName"

export type TaskResult = {
  readonly enum: TaskName.CONTENT_FILE
  readonly content: VirtualFile
  readonly name: string
}
